
/**
 * FallbackStylesProcessor - Creates fallback styles when external CSS can't be loaded
 */
export class FallbackStylesProcessor {
  /**
   * Creates a fallback style to use when external CSS can't be loaded
   */
  static createFallbackStyles(): HTMLStyleElement {
    console.log(`[DEBUG] FallbackStylesProcessor: Creating fallback styles`);
    const style = document.createElement('style');
    style.textContent = `
      /* Fallback styles when Tailwind can't be loaded */
      .onexip-calculator-container {
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif !important;
        color: #0f172a !important;
        line-height: 1.5 !important;
        width: 100% !important;
        max-width: 100% !important;
        background-color: #fff !important;
        border-radius: 0.5rem !important;
        overflow: hidden !important;
        margin: 0 auto !important;
        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1) !important;
      }
      
      /* Form styles */
      .onexip-calculator-container .form-card {
        border: 1px solid #e2e8f0 !important;
        border-radius: 0.5rem !important;
        padding: 1rem !important;
        margin-bottom: 1rem !important;
        background-color: white !important;
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06) !important;
      }
      
      /* Steps indicator styles */
      .onexip-calculator-container .step-item {
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
        position: relative !important;
        z-index: 2 !important;
        flex: 1 !important;
      }
      
      .onexip-calculator-container .step-item:not(:first-child):before {
        content: "" !important;
        position: absolute !important;
        height: 3px !important;
        width: 100% !important;
        background-color: #e2e8f0 !important;
        left: -50% !important;
        top: 1.25rem !important;
        transform: translateY(-50%) !important;
        z-index: 1 !important;
      }
      
      .onexip-calculator-container .step {
        width: 2.5rem !important;
        height: 2.5rem !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        border-radius: 9999px !important;
        background-color: #e2e8f0 !important;
        color: #64748b !important;
        font-weight: 600 !important;
        margin-bottom: 0.5rem !important;
        position: relative !important;
        z-index: 5 !important;
      }
      
      .onexip-calculator-container .step.active {
        background-color: #FB923C !important;
        color: white !important;
      }
      
      .onexip-calculator-container .step.complete {
        background-color: #FB923C !important;
        color: white !important;
      }
      
      .onexip-calculator-container .step-item p {
        margin-top: 0.5rem !important;
        text-align: center !important;
      }
      
      /* Selection card styles */
      .onexip-calculator-container .border {
        border: 1px solid #e2e8f0 !important;
      }
      
      .onexip-calculator-container .border-primary {
        border-color: #FB923C !important;
      }
      
      .onexip-calculator-container .rounded-lg {
        border-radius: 0.5rem !important;
      }
      
      .onexip-calculator-container .p-6 {
        padding: 1.5rem !important;
      }
      
      .onexip-calculator-container .bg-primary\\/10 {
        background-color: rgba(251, 146, 60, 0.1) !important;
      }
      
      /* Common Tailwind utility classes */
      .onexip-calculator-container .flex {
        display: flex !important;
        flex-direction: row !important;
      }
      
      .onexip-calculator-container .flex-col {
        flex-direction: column !important;
      }
      
      .onexip-calculator-container .justify-between {
        justify-content: space-between !important;
      }
      
      .onexip-calculator-container .items-center {
        align-items: center !important;
      }
      
      .onexip-calculator-container .text-center {
        text-align: center !important;
      }
      
      .onexip-calculator-container .max-w-4xl {
        max-width: 56rem !important;
      }
      
      .onexip-calculator-container .mx-auto {
        margin-left: auto !important;
        margin-right: auto !important;
      }
      
      /* Button styles */
      .onexip-calculator-container button {
        background-color: #FB923C !important;
        color: white !important;
        padding: 0.5rem 1rem !important;
        border-radius: 0.375rem !important;
        font-weight: 500 !important;
        cursor: pointer !important;
        border: none !important;
      }
      
      .onexip-calculator-container button:hover {
        background-color: #EA580C !important;
      }
      
      .onexip-calculator-container button:disabled {
        opacity: 0.5 !important;
        cursor: not-allowed !important;
      }
      
      /* Fix for icon positioning in step indicator */
      .onexip-calculator-container .step svg {
        width: 1.25rem !important;
        height: 1.25rem !important;
        display: block !important;
      }
    `;
    console.log(`[DEBUG] Created fallback styles element with ${style.textContent.length} characters`);
    return style;
  }
}
